module.exports = __webpack_public_path__ + "img/step10.c2f7f35c.png";